import type { FormJSONObject } from '@ikegps/core-api';
import { IkeId } from '../../id';
import { FormModel } from './form';
import { readMetadata, readParseDate, readSubForm } from './serializer/db.v1.read';
import { writeMetadata, writeSchema } from './serializer/db.v1.write';

export class IkeModelForm {
	create(): FormModel {
		const form = new FormModel();
		form.rootFormId = form.revision = form.version = IkeId.generate();
		form.createdAt = new Date();
		form.updatedAt = new Date();
		return form;
	}

	read(obj: FormJSONObject): FormModel {
		const createdForm = new FormModel();
		createdForm.createdAt = readParseDate(obj.createdAt);
		createdForm.updatedAt = readParseDate(obj.updatedAt);
		createdForm.updatedBy = obj.updatedBy;
		createdForm.name = obj.name;
		createdForm.description = obj.description;
		createdForm.displayName = obj.displayname;
		createdForm.displayVersion = obj.displayversion || 0;
		createdForm.revision = obj.version;
		createdForm.version = obj.version;
		createdForm.id = obj.objectId;
		createdForm.rootFormId = obj.uuid;

		if (obj.schema != null && Array.isArray(obj.schema.fields)) {
			readSubForm(createdForm, obj.schema);
		}

		readMetadata(createdForm, obj.metadata);

		return createdForm;
	}

	write(form: FormModel): FormJSONObject {
		return {
			uuid: form.rootFormId,
			objectId: form.id,
			version: form.revision,
			revision: form.revision,
			name: form.name,
			description: form.description,
			displayname: form.displayName,
			displayversion: form.displayVersion ?? undefined,
			updatedBy: form.updatedBy,
			schema: writeSchema(form),
			metadata: writeMetadata(form.metadata, form.fields),
			createdAt: form.createdAt != null ? form.createdAt.toISOString() : null,
			updatedAt: form.updatedAt != null ? form.updatedAt.toISOString() : null,
			v: 1,
			parser: 1,
		};
	}

	getAttachmentIds(form: FormJSONObject): string[] {
		if (form.metadata == null) {
			return [];
		}

		if (form.metadata.spidacalc != null && form.metadata.spidacalc.config != null) {
			return [form.metadata.spidacalc.config];
		}

		if (form.metadata.ocalc != null && form.metadata.ocalc.config != null) {
			return [form.metadata.ocalc.config];
		}

		if (
			form.metadata.poleforeman != null &&
			form.metadata.poleforeman.config != null &&
			!form.metadata.poleforeman.config.includes('sample')
		) {
			return [form.metadata.poleforeman.config];
		}

		if (form.metadata.ikePoleForeman != null && form.metadata.ikePoleForeman.config != null) {
			return [form.metadata.ikePoleForeman.config];
		}

		if (form.metadata.dds != null && form.metadata.dds.config != null) {
			return [form.metadata.dds.config];
		}

		return [];
	}
}
